import React from 'react'

const Hero = () => {
  return (
    <div className="container max-w-xl px-4 mx-auto mb-4">
      <div className="w-32 mx-auto "></div>
      <h2 className="mt-4 mb-8 text-5xl text-center">
        Mi vecino el narco: Zoom a los 981 centros de operaciones de traficantes
        en la RM
      </h2>

      <hr className="mb-4" />
      <p className="mb-4 text-center font-actasans">
        Por <strong>Sebastián Labrín y Felipe Díaz</strong>
      </p>

      <div className="content">
        <p className="firstLetter">
          Esquinas, casas usadas como centros de acopio y residencias
          reacondicionadas para funcionar como laboratorios. Son diversos los
          espacios urbanos que los narcotraficantes se han tomado en Santiago.
          La Unidad de Investigación y Datos de Tercera, tras identificar todas
          las direcciones en que se realizaron operativos antidrogas en el
          último año, levantó un mapa que exhibe el avance territorial del narco
          en la capital. 16 zonas asoman como críticas.
        </p>
      </div>
      <div>
        <h3>Contexto</h3>
        <p className="text-xl ">
          El narcotráfico se ha convertido en un foco de preocupación de
          diversas actividades, por el incremento y las nuevas manifestaciones
          de este delito.
        </p>
        <h3>Lo nuevo</h3>
        <p className="text-xl ">
          Investigación y Datos de La Tercera elaboró un mapa sobre el dominio
          que ha logrado el traficante en el Gran Santiago.
        </p>
        <h3>¿Por qué es importante?</h3>
        <p className="text-xl ">
          Identificando los lugares en que el narco se ha instalado, se pueden
          buscar los patrones en común y así crear fórmulas para erradicarlos.
        </p>
      </div>
    </div>
  )
}

export default Hero
